import globalMU from "globalMU"
import React from "react"

export interface DadosCashback {
    OidCliente: number
    NomeCliente: string
    CpfCnpjCliente: string
    Saldo: number
    Validade: string
    Utilizado: number
    DescricaoUtilizado: string
}

export type CashbackProps = {
    DadosCashback: Partial<DadosCashback>
}

export const Cashback = (props: CashbackProps) => {
    return (
        <>
            <div className="_my-4">
                <div className="_flex _items-center">
                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">CPF/CNPJ</label>
                    <p className="_mb-0 _p-2">{props.DadosCashback?.CpfCnpjCliente}</p>
                </div>
                <div className="_flex _items-center">
                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Nome</label>
                    <p className="_mb-0 _p-2">{props.DadosCashback?.NomeCliente}</p>
                </div>
                <div className="_flex _items-center">
                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Saldo Cashback</label>
                    <p className="_mb-0 _p-2">{globalMU.formatarValorNumerico(props.DadosCashback?.Saldo, 2, true)}</p>
                </div>
                <div className="_flex _items-center">
                    <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Válido até</label>
                    <p className="_mb-0 _p-2">{globalMU.formatDate(props.DadosCashback?.Validade)}</p>
                </div>
            </div>
        </>
    )
}